module.exports = {

  iteration: ( Utils, Api, workflowStepIterations, $stateParams ) ->
    iteration = Utils.getArrayItemById( workflowStepIterations, +$stateParams.iterationId )
    # When refining a search workflowStepIterations is not updated, so we fallback on an API
    # call instead
    if iteration
      return iteration
    else
      return Api.WorkflowStepIteration.get({id: $stateParams.iterationId}).$promise

  search: (Api, iteration) ->
    Api.Search.get({id: iteration.search}).$promise

  workers: (SearchWorkers, iteration) ->
    SearchWorkers.query({search: iteration.search}).$promise

  manualSources: (Api, iteration) ->
    Api.ManualWorkflowStepIteration.query({
      iteration: iteration.id
    }).$promise

  loadTemplates: ( $templateCache ) ->
    $templateCache.put('search-cockpit', require('./search-cockpit.html'))
    $templateCache.put('search-prev-iterations', require('./search-prev-iterations.html'))

}
